import { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import { Grid, Button, Switch, Divider, Typography, IconButton } from '@mui/material';
import { gridSpacing } from '../../../constant/Constants';
import { useMediaQuery, useTheme } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArticleIcon from '@mui/icons-material/Article';
import UpgradeIcon from '@mui/icons-material/Upgrade';
import { useDispatch, useSelector } from 'react-redux';
import { showAlert } from '../../../redux/create-actions/AlertAction';
import { resetCVV2, showOtpModalCardOperation } from '../../../redux/create-actions/OtpAction';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { showConfirmActiveCardModal, showConfirmUpgradeCardModal } from '../../../redux/create-actions/ConfirmAction';
import { formatMoney } from '../../../utils/function/Function';
import { closeLoadingApi, openLoadingApi } from '../../../redux/create-actions/LoadingAction';
import FontSize from '../../../layouts/FontSize';
import { graphGenOtp } from '../../../services/OneTimePassword';
import { setContractStatus } from '../../../services/CardOperation';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import GppGoodIcon from '@mui/icons-material/GppGood';


const paperStyle = { p: { xs: 2, md: 3 } };
const panStyle = { display: 'flex', justifyContent: 'center', justifyItems: 'center' };
const panText = { display: 'flex', alignItems: 'center' };
const divider = { my: 1.5 };
const btnStyle = { fontWeight: 700 };
const virtualText = { fontWeight: 600 };

export default function ContractDetail(props) {
    const { contract } = props;
    const theme = useTheme();
    const matchDownXL = useMediaQuery(theme.breakpoints.down('xl'));
    const data = useSelector(state => state.otp.data)
    const [ecomStatus, setEcomStatus] = useState(false);
    const [cvv, setCVV] = useState('');
    const [isShow, setIsShow] = useState(true);
    const [isShowContract, setIsShowContract] = useState(true);
    const [contractNumber, setContractNumber] = useState("");
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    const handleOpenConfirmUpgradeCardModal = () => {
        dispatch(showConfirmUpgradeCardModal('Confirm To Do Next Step', 'Do you want to continue to upgrade physical card?', props.contract.id, "UPGRADE_CARD"));
    }

    useEffect(() => {
        if (props.contract !== null) {
            setContractNumber(props.contract.contractNumber);
            if (data.contractId !== props.contract.id) {
                dispatch(resetCVV2());
                setCVV('');
                setIsShow(true);
                setEcomStatus(contract.contractDetails.way4Response.data.ecomStatus === 'ON_ECOM' ? true : false);
                setOpen(contract.contractDetails.way4Response.data.status === "Card OK" ? true : false);
            }
            if ((data.onEcom !== null && data.contractId === props.contract.id)) {
                setEcomStatus(data.onEcom);
            } if ((data.cvv2 !== '' & data.contractId === props.contract.id)) {
                setCVV(data.cvv2);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.contract, data.onEcom, data.contractId, data.cvv2, dispatch]);




    const handleActiveCard = () => {
        if (contract.contractDetails.way4Response.data.plasticStatus !== 'Active') {
            dispatch(showConfirmActiveCardModal('Confirm To Do Next Step', 'Do you want to continue to active card?', props.contract.id, "ACTIVE_CARD"))
        } else {
            let alert = {
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                isOpen: true,
                severity: 'info',
                title: 'Information',
                message: 'Your contract has been activated!'
            };
            dispatch(showAlert(alert));
        }
    };

    const handleSwitch = (event) => {
        let alert = {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            isOpen: true,
            severity: 'error',
            title: 'Error',
            message: ''
        };
        dispatch(openLoadingApi());
        let sendOtp = graphGenOtp();
        sendOtp
            .then(result => {
                if (true) {
                    if (result.GenerateOtp === "SMS") {
                        alert = { ...alert, severity: 'info', title: 'Information', message: "Please enter the OTP code sent to your phone number " }
                        dispatch(showAlert(alert));
                        let value = event.target.checked;
                        if (value === false) {
                            dispatch(closeLoadingApi());
                            dispatch(showOtpModalCardOperation(props.contract.id, "ECOMMERCE_ON"));
                        } else {
                            dispatch(closeLoadingApi());
                            dispatch(showOtpModalCardOperation(props.contract.id, "ECOMMERCE_OFF"));
                        }
                    } else {
                        alert = { ...alert, severity: 'info', title: 'Information', message: "Please enter the OTP code in your Google Authenticator App " }
                        dispatch(showAlert(alert));
                        let value = event.target.checked;
                        if (value === false) {
                            dispatch(closeLoadingApi());
                            dispatch(showOtpModalCardOperation(props.contract.id, "ECOMMERCE_ON"));
                        } else {
                            dispatch(closeLoadingApi());
                            dispatch(showOtpModalCardOperation(props.contract.id, "ECOMMERCE_OFF"));
                        }
                    }
                }
            }).catch(function (error) {
                alert = { ...alert, message: error };
                dispatch(closeLoadingApi());
                dispatch(showAlert(alert));
            })
    };

    const handleLock = () => {
        let alert = {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            isOpen: true,
            severity: 'error',
            title: 'Error',
            message: ''
        };
        dispatch(openLoadingApi());
        const lockStatus = open ? 'LOCK' : 'ACTIVE'
        const data = {
            contractId: parseInt(props.contract.id),
            newStatus: lockStatus
        }
        let lockCard = setContractStatus(data);
        lockCard.then(result => {
            alert = { ...alert, severity: 'success', title: 'Success', message: 'Change card status successful!' };
            dispatch(showAlert(alert));
            setOpen(!open);
            dispatch(closeLoadingApi());
        }).catch(() => {
            alert = { ...alert, message: 'Server error!' };
            dispatch(showAlert(alert));
            dispatch(closeLoadingApi());
        })
    }
    const handleShowCVV2 = () => {
        let alert = {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            isOpen: true,
            severity: 'error',
            title: 'Error',
            message: ''
        };
        if (data.cvv2 === '') {
            dispatch(openLoadingApi());
            let sendOtp = graphGenOtp();
            sendOtp
                .then(result => {
                    if (true) {
                        if (result.GenerateOtp === "SMS") {
                            alert = { ...alert, severity: 'info', title: 'Information', message: "Please enter the OTP code sent to your phone number " };
                            dispatch(closeLoadingApi());
                            dispatch(showAlert(alert));
                            dispatch(showOtpModalCardOperation(props.contract.id, "SHOW_CVV2"));
                        } else {
                            alert = { ...alert, severity: 'info', title: 'Information', message: "Please enter the OTP code in your Google Authenticator App" };
                            dispatch(closeLoadingApi());
                            dispatch(showAlert(alert));
                            dispatch(showOtpModalCardOperation(props.contract.id, "SHOW_CVV2"));
                        }
                    }
                }).catch(function (error) {
                    alert = { ...alert, message: error };
                    dispatch(closeLoadingApi());
                    dispatch(showAlert(alert));
                })
        } else {
            setCVV('');
            dispatch(resetCVV2());
        }
    };

    const handleShowContractNumber = () => {
        if (contractNumber !== props.contract.contractNumber) {
            setContractNumber(props.contract.contractNumber);
            setIsShowContract(true);
        } else {
            setContractNumber(props.contract.contractDetails.way4Response.data.cardNumber);
        }
    }

    const renderContractDetail = (contract, cvv2) => {
        return (
            <Paper variant="outlined" sx={paperStyle}>
                <Grid container>
                    <Grid container alignContent="center" justifyContent="space-between">
                        <Grid item>
                            <Button id="contract-detail" endIcon={<ArticleIcon />} sx={{ color: theme.typography.h3, cursor: 'default', fontSize: FontSize.Small, fontWeight: 700 }}>
                                Account Information
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={gridSpacing} sx={{ pl: matchDownXL ? 0 : 10, pr: matchDownXL ? 0 : 10, mt: 1, height: 60 }}>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> Account Number </Typography>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6} sx={panStyle}>
                                <Typography sx={panText}>
                                    {(contractNumber).slice(0, 4)} { }
                                    {(contractNumber).slice(4, 8).replace("__", "**")} { }
                                    {(contractNumber).slice(8, 12).replace("____", "****")} { }
                                    {(contractNumber).slice(12, 16)}
                                </Typography>
                                <IconButton size="small" color="primary" onClick={handleShowContractNumber}  >
                                    {!isShowContract ? <VisibilityIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                                </IconButton>
                            </Grid>
                        </Grid>
                        <Divider sx={divider} />
                        <Grid container spacing={gridSpacing} sx={{ pl: matchDownXL ? 0 : 10, pr: matchDownXL ? 0 : 10, mt: 1, height: 60 }}>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> Contract Type </Typography>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> {contract.contractType} </Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={divider} />
                        <Grid container spacing={gridSpacing} sx={{ pl: matchDownXL ? 0 : 10, pr: matchDownXL ? 0 : 10, mt: 1, height: 60 }}>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> Full Name </Typography>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> {contract.embossingName} </Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={divider} />
                        <Grid container spacing={gridSpacing} sx={{ pl: matchDownXL ? 0 : 10, pr: matchDownXL ? 0 : 10, mt: 1, height: 60 }}>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> Valid From </Typography>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> {contract.issuedDate} </Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={divider} />
                        <Grid container spacing={gridSpacing} sx={{ pl: matchDownXL ? 0 : 10, pr: matchDownXL ? 0 : 10, mt: 1, height: 60 }}>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> Good Thur </Typography>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> {contract.expiredDate} </Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={divider} />
                        <Grid container spacing={gridSpacing} sx={{ pl: matchDownXL ? 0 : 10, pr: matchDownXL ? 0 : 10, mt: 1, height: 60 }}>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> Product </Typography>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> {contract.product.name} </Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={divider} />
                    </Grid>
                    <Grid item xs={12} >
                        <Grid container spacing={gridSpacing} sx={{ pl: matchDownXL ? 0 : 10, pr: matchDownXL ? 0 : 10, mt: 1, height: 60 }}>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> Card Type </Typography>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}>
                                {contract.contractDetails.way4Response.data.cardType === 'V' ?
                                    <div> <span style={virtualText}> Virtual/ </span>
                                        <Button size="small" sx={btnStyle} endIcon={<UpgradeIcon />} onClick={handleOpenConfirmUpgradeCardModal}>Upgrade</Button></div>
                                    : <Typography color="primary" >Physical</Typography>
                                }
                            </Grid>
                        </Grid>
                        <Divider sx={divider} />
                        <Grid container spacing={gridSpacing} sx={{ pl: matchDownXL ? 0 : 10, pr: matchDownXL ? 0 : 10, mt: 1, height: 60 }}>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> Balance </Typography>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}>
                                <Button size="small" sx={btnStyle} endIcon={!isShow ? <VisibilityIcon onClick={() => { setIsShow(!isShow) }} /> : <VisibilityOffIcon onClick={() => { setIsShow(!isShow) }} />} > {!isShow ? formatMoney(contract.contractDetails.way4Response.data.balance, ' VND') : <>**********</>}</Button>
                            </Grid>
                        </Grid>
                        <Divider sx={divider} />
                        <Grid container spacing={gridSpacing} sx={{ pl: matchDownXL ? 0 : 10, pr: matchDownXL ? 0 : 10, mt: 1, height: 60 }}>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> CVV2 </Typography>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}>
                                <Button sx={btnStyle} size="small" endIcon={cvv2 !== '' ? <VisibilityIcon /> : <VisibilityOffIcon />} onClick={handleShowCVV2}> {cvv2} </Button>
                            </Grid>
                        </Grid>
                        <Divider sx={divider} />
                        <Grid container spacing={gridSpacing} sx={{ pl: matchDownXL ? 0 : 10, pr: matchDownXL ? 0 : 10, mt: 1, height: 60 }}>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> Ecommerce </Typography>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}>
                                <Switch
                                    checked={ecomStatus}
                                    onChange={handleSwitch}
                                />
                            </Grid>
                        </Grid>
                        <Divider sx={divider} />
                        <Grid container spacing={gridSpacing} sx={{ pl: matchDownXL ? 0 : 10, pr: matchDownXL ? 0 : 10, mt: 1, height: 60 }}>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> Status </Typography>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}>
                                <Switch
                                    checked={open}
                                    onChange={handleLock}
                                />
                            </Grid>
                        </Grid>
                        <Divider sx={divider} />
                        <Grid container spacing={gridSpacing} sx={{ pl: matchDownXL ? 0 : 10, pr: matchDownXL ? 0 : 10, mt: 1, height: 60 }}>
                            <Grid item sm={6} xs={6} md={6}>
                                <Typography variant="h5"> Plastic Status </Typography>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}>
                                {(["Ready", "Locked", "Locked for Online"].includes(contract.contractDetails.way4Response.data.productionStatus)) ? (
                                    <>
                                        {contract.contractDetails.way4Response.data.plasticStatus !== "Active" ? (
                                            <Button onClick={handleActiveCard} size="small" color="error" variant='contained' endIcon={<FlashOnIcon style={{ color: 'yellow' }} />}>
                                                <Typography variant="h5" style={{ color: '#fff' }}>NOT ACTIVE</Typography>
                                            </Button>
                                        ) : (
                                            <Button size="small" color="primary" variant='contained' style={{ cursor: 'text' }} endIcon={<GppGoodIcon style={{ color: 'green' }} />}>
                                                <Typography variant="h5" style={{ color: '#fff' }}>ACTIVE</Typography>
                                            </Button>
                                        )
                                        }
                                    </>
                                ) : <>
                                    <Button size="small" color="warning" variant='contained' style={{ color: 'red', cursor: 'text' }} endIcon={<RocketLaunchIcon style={{ color: 'red', cursor: 'text' }} />}>
                                        <Typography variant="h5" style={{ color: '#000', cursor: 'text' }}>Waiting</Typography>
                                    </Button>
                                </>}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        )
    }

    return contract !== null ? (
        <Grid>
            {renderContractDetail(contract, cvv)}
        </Grid>
    ) : (
        <Paper variant="outlined" sx={paperStyle}> </Paper>
    );
}